import { db } from './data_oscbase';
import { TestDataManager } from './TestDataManager';

// Service d'initialisation de la base de données
export const initService = {
  initDatabase: async () => {
    try {
      // Ouvrir la base de données
      await db.open();
      console.log('Base de données initialisée avec succès');

      // Vérifier si l'admin existe
      const adminExists = await db.users.where('role').equals('admin').first();
      if (!adminExists) {
        // Créer le compte admin par défaut
        await db.users.add({
          username: 'administrator',
          password: 'OSC@dm1n2024!', // Mot de passe sécurisé avec majuscules, chiffres et caractères spéciaux
          role: 'admin',
          createdAt: new Date(),
          updatedAt: new Date()
        });
        console.log('Compte administrateur créé avec succès');
      }

      // Initialiser les données de test (même en production)
      try {
        console.log('🔄 Initialisation des données de test...');
        await TestDataManager.initializeBackupData();
        console.log('✅ Données de test initialisées avec succès');
      } catch (error) {
        console.warn('⚠️ Erreur lors de l\'initialisation des données de test:', error);
      }

      return true;
    } catch (error) {
      console.error('Erreur lors de l\'initialisation de la base de données:', error);
      return false;
    }
  }
}; 